import { autoInjectable, container } from 'tsyringe';
import { EpStore } from '../services/store/ep-store';
import { ofType } from 'deox';
import { OverlayActions, PluginActions, RtpsActions } from '../actions';
import { catchError, exhaustMap, filter, map, switchMap, tap } from 'rxjs/operators';
import { CommonEffect } from './common-effect';
import { PublicEventEmitterService } from '../services/public-event-emitter/public-event-emitter.service';
import { Analytics } from '../modules/analytics/analytics';
import { merge, of } from 'rxjs';
import {
  applicationComplete,
  fetchPrescreen,
  offerResponse,
  OfferResponseType,
  pathForRtps,
  PrescreenResult,
  fetchVirtualLookup,
  pathForBps, RtpsMockOptions, VirtualLookupResult, cancelApplication
} from 'fmc-sdk';
import { fromPromise } from 'rxjs/internal-compatibility';
import { displayPrescreenApprovedOffer } from '../actions/rtps.actions';
import { ConfigUtilService } from '../services/config/config-util.service';
import {
  FetchRtpsMockOptions,
  getPreScreenBodyFromCustomerInfo, getRtpsMockOptions,
  RTPS_OVERLAY_CONTENT_ID,
  VirtualLookupMockOptions
} from '../models/rtps.model';
import { OverlayContentType } from '../models/overlay.model';
import { OverlayService } from '../services/overlay/overlay.service';
import { BreadLoader } from '../modules/bread/bread-loader';

@autoInjectable()
export class PluginEffects implements CommonEffect {

  initPlugins$ = this.store.actions$.pipe(
    ofType(PluginActions.initPlugins),
    map(() =>
      this.configUtilService.getConfig().plugins
    ),
    tap(pluginConfig => {
      this.store.dispatch(
        PluginActions.initBreadPlugin(pluginConfig.bread)
      );
    })
  );

  initBreadPlugin$ = this.store.actions$.pipe(
    ofType(PluginActions.initBreadPlugin),
    map(action => action.payload),
    filter(breadPluginConfig => breadPluginConfig.enabled),
    tap((breadConfig) =>{
      BreadLoader.load(breadConfig);
    })
  );

  contentAddedToDom$ = this.store.actions$.pipe(
    ofType(PluginActions.contentAddedToDom),
    tap(action => {
      this.store.dispatch(PluginActions.contentAddedToDomBread(action.payload));
    })
  );

  contentAddedToDomBread$ = this.store.actions$.pipe(
    ofType(PluginActions.contentAddedToDomBread),
    map(action => action.payload),
    filter(({domTarget})=>{
      const breadPlacements = domTarget.querySelectorAll('[data-action-type="BREAD_APPLY"]');
      return (breadPlacements.length > 0 && !!(window as any).bread);
    }),
    tap(({domTarget})=>{
      (window as any).bread.apply();
      // noinspection JSDeprecatedSymbols
      (window as any).bread.events.subscribe('onCustomerOpen', (err, data, callback) => {
        this.store.dispatch(OverlayActions.closeOverlay());
        callback(true);
      });
    })
  );

  constructor(private store?: EpStore,
              private configUtilService?: ConfigUtilService
  ) {
  }

  bindSideEffects() {
    return merge(
      this.initPlugins$,
      this.contentAddedToDom$,
      this.initBreadPlugin$,
      this.contentAddedToDomBread$,
    ).subscribe();
  }
}
